<template>
  <div class="bg">
    <div class="header_nav">
      <div class="logo">
        <a href="/"><img class="brand-img" src="../../public/images/icon/17.png" height="60" alt /></a>
      </div>
      <div class="menu">
        <div class="li"><a href="/">首页</a></div>
        <div :class="actived == 1 ? 'li active' : 'li'"><a href="/yitku/#/web/index">题库</a></div>
        <!-- <div class="li">刷题自习室</div>-->
        <!-- <div :class="actived == 4 ? 'li active' : 'li'"><a href="/yitku/#/web/knowledge">考点速记</a></div> -->
        <div :class="actived == 3 ? 'li active' : 'li'"><a href="/yitku/#/web/square">考友圈</a></div>
        <div :class="actived == 2 ? 'li active' : 'li'"><a href="/yitku/#/web/shop">商城</a></div>
        <!-- <div class="li">VIP会员</div> -->
        <div class="li"><a href="https://www.yitku.com/miapp" target="_blank">APP下载</a></div>
        <div class="btn" @click="goUserCenter()" v-if="showTextLogin">用户中心</div>
        <div class="btn" v-else @click="showLogin();">登录/注册</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HeaderTon",
  props: {
    msg: String,
    actived: { default: 0 },
  },
  data() {
    return {
      showTextLogin: false,
    };
  },
  created() {
    let token = sessionStorage.getItem("access-token");
    if (token) {
      this.showTextLogin = true;
    }
  },
  methods: {
    showLogin() {
      this.$emit("boxLogin", "子向父组件传值");
    },

    goUserCenter() {
      this.$router.push("/users/seeting");
    },
  },
};
</script>

<style>
.bg {
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
}

.bg .header_nav {
  width: 1200px;
  margin: 0 auto;
  height: 80px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.bg .header_nav .logo,
.bg .header_nav .brand-img {
  width: 100px;
  height: 44px;
}

.bg .header_nav .menu {
  width: 72%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.bg .header_nav .menu .li {
  text-align: center;
  padding: 0 20px;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
}

.bg .header_nav .menu .li a {
  font-size: 18px;
  color: #333333;
}

.bg .header_nav .menu .li a:hover {
  color: #366dfa;
}

.bg .header_nav .menu .li.active a {
  color: #366dfa;
}

.bg .header_nav .menu .btn {
  width: 96px;
  height: 36px;
  background: #366dfa;
  border-radius: 8px;
  text-align: center;
  line-height: 36px;
  color: #fff;
  font-size: 14px;
  margin-left: 15px;
  cursor: pointer;
}
</style>